import React, { FunctionComponent } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { AppBar } from '@material-ui/core';

interface Attributes {
  flexdirection:
    | 'inherit'
    | 'initial'
    | '-moz-initial'
    | 'revert'
    | 'unset'
    | 'column'
    | 'column-reverse'
    | 'row'
    | 'row-reverse';
  textcolor: string;
  background: string;
}

const WEAppBarElement = withStyles({
  root: (attributes: Attributes) => ({
    position: 'static',
    display: 'flex',
    flexDirection: attributes.flexdirection,
    color: attributes.textcolor,
    background: attributes.background,
    padding: '0 10px',
    '& button': {
      minWidth: 'auto',
      padding: '6px 22px',
      textTransform: 'capitalize',
      '&.Mui-selected': {
        color: '#304ffe',
      },
    },
    '& .MuiTabs-indicator': {
      backgroundColor: '#304ffe',
    },
  }),
})(AppBar);

const WEAppBar = (props: any) => {
  const attributes = { ...props };
  if (!attributes.textcolor) {
    attributes.textcolor = '#3A3A3A';
  }
  if (!attributes.background) {
    attributes.background = '#FFFFFF';
  }
  if (!attributes.flexdirection) {
    attributes.flexdirection = 'row';
  }
  if (!attributes.elevation) {
    attributes.elevation = 0;
  }
  const children = props.children;

  return <WEAppBarElement {...attributes}>{children}</WEAppBarElement>;
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

interface Props {
  value: number;
  tabs: Array<Item>;
  handleChange: any;
}

interface Item {
  name: string;
}

const SimpleTabs: FunctionComponent<Props> = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <WEAppBar>
        <Tabs value={props.value} onChange={props.handleChange} aria-label="simple tabs example">
          {props.tabs.map((item: Item, index: number) => (
            <Tab key={index} label={item.name} />
          ))}
        </Tabs>
      </WEAppBar>
    </div>
  );
};

export default SimpleTabs;
